import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { Company } from 'app/models/company.model';
import { ContainerEnum } from 'app/models/container.enum';
import { GeneralContainerReport } from 'app/models/general-container-report.model';
import { Poligon } from 'app/models/poligon.model';
import { CompanyService } from 'app/services/company.service';
import { ExcelService } from 'app/services/excel.service';
import { GeneralReportService } from 'app/services/general-report.service';
import { PoligonService } from 'app/services/poligon.service';
import { SimulationService } from 'app/services/simulation.service';
import { ApexAxisChartSeries, ApexChart, ApexDataLabels, ApexLegend, ApexStroke, ApexTheme, ApexTitleSubtitle, ApexXAxis, ApexYAxis, ChartComponent } from 'ng-apexcharts';
import { NgxSpinnerService } from 'ngx-spinner';

export type ChartOptions = {
    series: ApexAxisChartSeries;
    chart: ApexChart;
    xaxis: ApexXAxis;
    stroke: ApexStroke;
    theme: ApexTheme;
    dataLabels: ApexDataLabels;
    yaxis: ApexYAxis;
    title: ApexTitleSubtitle;
    labels: string[];
    legend: ApexLegend;
    subtitle: ApexTitleSubtitle;
  };
  
@Component({
    selector: 'simulation-general-container-report-list',
    templateUrl: './simulation-general-container-report-list.component.html',
    styleUrls: ['./simulation-general-container-report-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    providers: [ExcelService]
})
export class SimulationGeneralContainerReportListComponent implements OnInit {

    @ViewChild(MatSort) private _sort: MatSort;
    @ViewChild(MatPaginator) private _paginator: MatPaginator;
    
    @ViewChild("chartMaxOccupancy") chartMaxOccupancy: ChartComponent;
    public chartOptionsMaxOccupancy: Partial<ChartOptions>;

    @ViewChild("chartProductivity") chartProductivity: ChartComponent;
    public chartOptionsProductivity: Partial<ChartOptions>;

    public tableLoading = false;
    public selectByFilter = "year"
    public StartTime: Date;
    public EndTime: Date
    public polygonId:number;
    public companyId:number;
    public rootCompanyId;

    private _filterText: string = '';
    public get filterText(): string {
        return this._filterText;
    }
    public set filterText(v: string) {
        this._filterText = v.trim().toLowerCase();
        this._dataSource.filter = this._filterText;
    }
    
    
    private _polygons : Array<Poligon> = [];
    public get polygons() : Array<Poligon> {
        return this._polygons;
    }
    public set polygons(v : Array<Poligon>) {
        this._polygons = v;
    }

    
    private _companies : Array<Company> = [];
    public get companies() : Array<Company> {
        return this._companies;
    }
    public set companies(v : Array<Company>) {
        this._companies = v;
    }
    
    
    
    public _generalContainerReport: Array<GeneralContainerReport>
    
    private _dataSource: MatTableDataSource<GeneralContainerReport> = undefined;
    public get dataSource(): MatTableDataSource<GeneralContainerReport> {
        return this._dataSource;
    }

    private _displayedColumns = ['name','type', 'volume','totalDay', 'processedDay', 'maxOccupancy','totalGarbageProduced',"productivity","transactionFrequency"];

    public get displayedColumns(): Array<string> {
        return this._displayedColumns;
    }

    constructor(
        private route: ActivatedRoute,
        private _companyService: CompanyService,
        private _simulationService:SimulationService,
        private _excelService: ExcelService,
        private _spinner:NgxSpinnerService,
        ) {
        this.companyId = parseInt(localStorage.getItem("CompanyID"));
        this.rootCompanyId = parseInt(localStorage.getItem("CompanyID"));
        this.chartOptionsMaxOccupancy = {
            series: [
                {
                  name: "Max Doluluk",
                  data: [0,0]
                }
              ],
              chart: {
                type: "area",
                height: 350,
                zoom: {
                  enabled: false
                }
              },
              dataLabels: {
                enabled: false
              },
              stroke: {
                curve: "straight"
              },
              labels: [],
              xaxis: {
                type: "category"
              },
              yaxis: {
                opposite: true
              },
              legend: {
                horizontalAlign: "left"
              }
          };

        this.chartOptionsProductivity = {
            series: [
                {
                  name: "Tasarruf",
                  data: [0,0]
                }
              ],
              chart: {
                type: "area",
                height: 350,
                zoom: {
                  enabled: false
                }
              },
              dataLabels: {
                enabled: false
              },
              stroke: {
                curve: "straight"
              },
        
              title: {
                text: "Ulaşılan Max Doluluk",
                align: "left"
              },
              labels: [],
              xaxis: {
                type: "category"
              },
              yaxis: {
                opposite: true
              },
              legend: {
                horizontalAlign: "left"
              }
          };
    }


    public async ngOnInit() {
        await this.getCompanies();    
        await this.getPolygonList();
        if(this.companyId==1){
            this.companyId = this.companies.find(x=>x.id !=1).id;
        }
        
        this.route.queryParams
        .subscribe(params => {
            if(params.start_date && params.end_date && params.zone)
            {
                this.polygonId = this.polygons.find(x=>x.name == params.zone).id;
                var startDate = new Date(params.start_date);
                var endDate = new Date(params.end_date);
                
                // Tarihlerin ay ve gün değerlerini yer değiştiriyoruz
                var formattedStartDate = startDate.toLocaleDateString('en-GB');
                var formattedEndDate = endDate.toLocaleDateString('en-GB');
                this.onTimeChangeClick("special", new Date(formattedStartDate),new Date(formattedEndDate))
            }
            else{
                this.onTimeChangeClick("year");
            }
        });

        this.polygonId = this.polygons[0].id;
        this.updateTableDataSource()
    }

    public async getGeneralContainerReportList(){
        try {
            this._generalContainerReport = await this._simulationService.getGeneralContainerReport(this.companyId,this.StartTime,this.EndTime,this.polygonId);
        } catch (error) {
            console.warn(error);
        }
    }

    private async getPolygonList() {
        try {
            this.polygons = await this._simulationService.getPoligons(this.companyId);
        } catch (error) {
            console.warn(error);
        }
    }

    private async getCompanies(){
        try {
            this.companies = await this._companyService.getCompanies();
        } catch (error) {
            console.warn(error);
        }
    }

    // public async onReportClick() {
    //     const columns = ["No","Konteyner Adı", "Cihaz id", "Tarih","Boşaltılmadan Önce Tarih","Boşaltılmadan Sonra Tarih" ,"Boşaltılmadan Önce", "Boşaltıldıktan Sonra", "Adres"];
    //     let idx = 1;
    //     const dataset = this._generalContainerReport.map(p => {
    //         return {
    //             index: idx++,
    //             name: `${p.containerName}`,
    //             cihazId: `${p.deviceId}`,
    //             beforetarih: `${p.beforeDate}`,
    //             aftertarih: `${p.afterDate}`,
    //             dolulukOnce: `${p.beforeOccupancy}`,
    //             dolulukSonra: `${p.afterOccupancy}`,
    //             Address: `${p.address}`,

    //         }
    //     });
    //     this._excelService.exportAsExcelFile(
    //         columns,
    //         dataset,
    //         'Çöp Boşaltım Raporu',
    //         "",
    //         new Date(),
    //         {
    //             worksheetName: 'Çöp Boşaltım Raporu'
    //         }
    //     );
    // }

    public onTimeChangeClick(key: string, startTime?: Date, endTime?: Date) {
        switch (key) {
            case "day":
                var end = new Date();
                var start = new Date(end.getFullYear(),end.getMonth(),end.getDate()-1,0,0);
                this.StartTime = start;
                this.EndTime = end
                break;
            // case "week":
            //     var end = new Date();
            //     var start = new Date(end.getFullYear(),end.getMonth(),end.getDate()-7,0,0);
            //     this.StartTime = start;
            //     this.EndTime = end
            //     break;
            case "year":
                var end = new Date();
                var start = new Date(end.getFullYear(),0,1,0,0);
                this.StartTime = start;
                this.EndTime = end
                this.selectByFilter = key;

                break;
            case "month":
                var end = new Date();
                var start = new Date(end.getFullYear(),end.getMonth(),1,0,-1);
                this.StartTime = start;
                this.EndTime = end
                break;

            default:
                this.StartTime = startTime;
                this.EndTime = endTime
                break;
        }
        this.refresh();
    }
    
    private async updateTableDataSource(): Promise<void> {
        this._dataSource = new MatTableDataSource<GeneralContainerReport>(this._generalContainerReport);
        this._dataSource.paginator = this._paginator;
        this._dataSource.sort = this._sort;
    }

    public async setMaxOccupancyChart(){
        var data = [];
        var label = [];
        this._generalContainerReport.forEach(x=>{
            data.push(x.maxOccupancy);
            label.push(x.name?x.name:"");
        });
        this.chartOptionsMaxOccupancy = {
            series: [
                {
                  name: "Max Doluluk",
                  data: data
                }
              ],
              chart: {
                type: "area",
                height: 350,
                zoom: {
                  enabled: false
                }
              },
              theme: {
                mode: 'dark', 
                palette: 'palette1', 
                monochrome: {
                    enabled: false,
                    color: '#255aee',
                    shadeTo: 'dark',
                    shadeIntensity: 0.65
                },
            },
              dataLabels: {
                enabled: false
              },
              
              stroke: {
                curve: "straight"
              },
              labels: label,
              xaxis: {
                type: "category"
              },
              yaxis: {
                opposite: false,
                max:100,
                min:0
              },
              legend: {
                horizontalAlign: "left"
              }
          };
    }

    public async setProductivityChart(){
        var data = [];
        var label = [];
        this._generalContainerReport.forEach(x=>{
            data.push(100-x.productivity);
            label.push(x.name?x.name:"");
        });
        this.chartOptionsProductivity = {
            series: [
                {
                  name: "Tasarruf",
                  data: data
                }
              ],
              chart: {
                type: "area",
                height: 350,
                zoom: {
                  enabled: false
                }
              },
              theme: {
                mode: 'dark', 
                palette: 'palette1', 
                monochrome: {
                    enabled: false,
                    color: '#255aee',
                    shadeTo: 'dark',
                    shadeIntensity: 0.65
                },
            },
              dataLabels: {
                enabled: false
              },
              
              stroke: {
                curve: "straight"
              },
              labels: label,
              xaxis: {
                type: "category"
              },
              yaxis: {
                opposite: false,
                max:100,
                min:0
              },
              legend: {
                horizontalAlign: "left"
              }
          };
    }



    public async refresh(){
        this.getPolygonList()
        await this.getGeneralContainerReportList();
        await this.updateTableDataSource();
        this.setMaxOccupancyChart();
        this.setProductivityChart();
    }
}
